export default {"src":"/_next/static/image/src/assets/img/gear-loading.056767e6e9bcf986848a67a772381389.svg","height":204,"width":204};